import { render, staticRenderFns } from "./InfoEmail.vue?vue&type=template&id=35a1aa5d&scoped=true&"
import script from "./InfoEmail.vue?vue&type=script&lang=js&"
export * from "./InfoEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1aa5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a1aa5d')) {
      api.createRecord('35a1aa5d', component.options)
    } else {
      api.reload('35a1aa5d', component.options)
    }
    module.hot.accept("./InfoEmail.vue?vue&type=template&id=35a1aa5d&scoped=true&", function () {
      api.rerender('35a1aa5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/InfoEmail.vue"
export default component.exports